import React, { ComponentType, LazyExoticComponent } from 'react'
import { Link, matchPath } from 'react-router-dom'

import layoutRoutes from '@Pages/index'
import { Preload } from '@Types/inner/Preload'
import { AppRoute } from '@Types/inner/AppRoute'

export function ReactLazyPreload<T extends ComponentType<any>>(importStatement: Preload<T>) {
  const Component = React.lazy(importStatement) as LazyExoticComponent<T> & { preload: Preload<T> }
  Component.preload = importStatement
  return Component
}

function preloadRouteComponent(to: string, onPreload: (() => void)[]) {
  const routes = layoutRoutes.map(({ routes }) => routes)

  routes.some((route) => {
    const component = findComponentForRoute(to, route)

    component?.forEach((component) => {
      if (component && component.preload) {
        component.preload()
      }
    })
    if (onPreload) {
      return Promise.all(onPreload.map((action) => action()))
    }
  })
}

function findComponentForRoute<T extends ComponentType<any>>(path: string, routes: AppRoute<T>[]): (LazyExoticComponent<T> & { preload: Preload<T> })[] | null | undefined {
  const matchingRoute = routes.find((route) =>
    matchPath(path, {
      path: route.path,
      exact: route.exact,
    }),
  )
  if (matchingRoute) {
    return routes.map(({ component }) => component)
  }

  // if (matchingRoute && matchingRoute.routes) {
  //   return findComponentForRoute(path, matchingRoute.routes)
  // }

  // return matchingRoute ? matchingRoute.component : null
}

type PreloadLinkParam = { to: string; onPreload: (() => void)[] }
export const PreloadLink: React.FC<PreloadLinkParam> = ({ to, onPreload, ...rest }: PreloadLinkParam) => {
  return <Link to={to} onMouseEnter={() => preloadRouteComponent(to, onPreload)} {...rest} />
}
